module.exports = __webpack_public_path__ + "img/dots.af87fe6d.svg";